import { z } from 'zod';
import { StructuredClinicalSummarySchema } from '../clinical-summary';
import { DisplayReferenceSchema } from '../domain/models';

export const ResourceNoteSchema = z.object({
  author: DisplayReferenceSchema,
  text: z.string(),
  time: z.string(),
  structuredContent: StructuredClinicalSummarySchema.optional(),
});

export type ResourceNote = z.infer<typeof ResourceNoteSchema>;
